import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { HERO_SLIDES } from "../data/siteContent";
import MarqueeBand from "./MarqueeBand";

export default function Hero() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIndex((i) => (i + 1) % HERO_SLIDES.length), 6000);
    return () => clearInterval(t);
  }, []);

  const slide = HERO_SLIDES[index];

  return (
    <section id="home" className="relative min-h-screen w-full overflow-hidden">
      <AnimatePresence mode="wait">
        <motion.div
          key={slide.image + index}
          className="absolute inset-0"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.1, ease: "easeInOut" }}
        >
          <img
            src={slide.image}
            alt=""
            className="h-full w-full animate-ken-burns object-cover object-center"
          />
        </motion.div>
      </AnimatePresence>

      <div className="hero-slide-overlay-left pointer-events-none absolute inset-0 z-[1]" />
      <div className="hero-slide-overlay-bottom pointer-events-none absolute inset-0 z-[1]" />
      <div
        className="pointer-events-none absolute inset-0 z-[1] opacity-50"
        style={{
          background:
            "radial-gradient(ellipse 80% 60% at 15% 40%, rgba(99,102,241,0.2), transparent 55%), radial-gradient(ellipse 50% 40% at 90% 20%, rgba(139,92,246,0.12), transparent)",
        }}
      />

      <div className="relative z-10 flex min-h-screen flex-col">
        <div className="mx-auto flex w-full max-w-7xl flex-1 flex-col justify-center px-4 pb-36 pt-28 sm:px-6 sm:pb-40 lg:px-8 lg:pt-32">
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15, duration: 0.7 }}
            className="hero-eyebrow mb-6"
          >
            <span className="text-accent-light">•</span> Inception Creative — Est. 2012
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 28 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.25, duration: 0.85 }}
            className="title-editorial max-w-4xl text-4xl sm:text-5xl lg:text-6xl xl:text-[4.25rem]"
          >
            We craft brands that{" "}
            <span className="italic text-gradient-hero">dominate attention</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.7 }}
            className="mt-6 max-w-xl font-sans text-base leading-relaxed text-white/75 sm:text-lg"
          >
            Corporate-grade advertising, social media, branding, and print — designed with editorial
            precision.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.55, duration: 0.7 }}
            className="mt-9 flex flex-wrap gap-4"
          >
            <a href="#portfolio" className="btn-primary-corp">
              Start Creating
            </a>
            <a href="#portfolio" className="btn-outline-corp border-white/30 bg-transparent hover:bg-white/10">
              View Portfolio
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.75 }}
            className="mt-10 flex gap-2"
            aria-hidden
          >
            {HERO_SLIDES.map((s, i) => (
              <button
                key={s.tag}
                type="button"
                onClick={() => setIndex(i)}
                className={`h-1 rounded-full transition-all duration-500 ${
                  i === index ? "w-10 bg-white/90" : "w-4 bg-white/30 hover:bg-white/50"
                }`}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </motion.div>
        </div>

        <MarqueeBand embedded />
      </div>
    </section>
  );
}
